export const FETCH_DOMAINS_REQUEST = 'FETCH_DOMAINS_REQUEST';
export const FETCH_DOMAINS_SUCCESS = 'FETCH_DOMAINS_SUCCESS';
export const FETCH_DOMAINS_FAILURE = 'FETCH_DOMAINS_FAILURE';
